import { createUser } from '../models/user';

const userMapper = {
    toDomain(userData) {
        return createUser({
            id: userData.id,
            email: userData.email,
            isAuthenticated: true
        });
    }
};

export {
    userMapper
};
